/**
 * initSlideSlider — hero-style slider with multiple animation types
 *
 * opts.trackEl   — element containing .hero-slide children
 * opts.dotsEl    — optional element to render nav dots into
 * opts.pauseEl   — element that pauses on mouseenter
 * opts.interval  — autoplay ms
 * opts.anim      — 'fade' | 'zoom' | 'slide-x' | 'slide-y'
 * opts.duration  — transition duration ms (should match CSS)
 */
function initSlideSlider(opts) {
    var slides = Array.from(opts.trackEl.querySelectorAll('.hero-slide'));
    if (!slides.length) return;

    var anim = opts.anim || 'fade';
    var duration = opts.duration || 700;
    var current = 0;
    var timer;
    var busy = false;

    opts.trackEl.dataset.anim = anim;
    slides[0].classList.add('is-active');

    if (slides.length <= 1) return;

    function go(n) {
        if (busy) return;
        busy = true;

        var prev = current;
        current = (n + slides.length) % slides.length;

        slides[prev].classList.add('is-leaving');
        slides[current].classList.add('is-entering', 'is-active');
        slides[prev].classList.remove('is-active');

        setTimeout(function () {
            slides[current].classList.remove('is-entering');
        }, duration);

        if (opts.dotsEl) {
            opts.dotsEl.querySelectorAll('button').forEach(function (b, i) {
                b.classList.toggle('is-active', i === current);
            });
        }

        setTimeout(function () {
            slides[prev].classList.remove('is-leaving');
            busy = false;
        }, duration);
    }

    function start() {
        clearInterval(timer);
        timer = setInterval(function () { go(current + 1); }, opts.interval);
    }

    function stop() { clearInterval(timer); }

    if (opts.dotsEl) {
        slides.forEach(function (_, i) {
            var btn = document.createElement('button');
            btn.setAttribute('aria-label', 'Slide ' + (i + 1));
            btn.addEventListener('click', function () {
                if (i === current) return;
                go(i);
                start();
            });
            opts.dotsEl.appendChild(btn);
        });
        opts.dotsEl.querySelector('button').classList.add('is-active');
    }

    if (opts.pauseEl) {
        opts.pauseEl.addEventListener('mouseenter', stop);
        opts.pauseEl.addEventListener('mouseleave', start);
    }

    start();
}


/**
 * initTextSlider — testimonial-style text fade slider
 *
 * opts.items    — array of { q, name, org }
 * opts.quoteEl  — element to render quote text into
 * opts.attrEl   — element to render name/org into
 * opts.dotsEl   — element to render nav dots into
 * opts.pauseEl  — optional element that pauses on mouseenter
 * opts.interval — autoplay ms
 */
function initTextSlider(opts) {
    var items = opts.items;
    if (!items || !items.length) return;

    var current = 0;
    var timer;

    // lock quote + attr heights to the tallest item so layout doesn't shift
    function measureAndLock() {
        var prevQ = parseFloat(opts.quoteEl.style.minHeight) || 0;
        var prevA = parseFloat(opts.attrEl.style.minHeight) || 0;
        opts.quoteEl.style.minHeight = '';
        opts.attrEl.style.minHeight = '';
        var maxQ = prevQ;
        var maxA = prevA;
        items.forEach(function (item) {
            opts.quoteEl.innerHTML = '"' + item.q + '"';
            opts.attrEl.innerHTML =
                '<div class="org">' + item.org + '</div>' +
                '<div class="name">' + item.name + '</div>';
            maxQ = Math.max(maxQ, opts.quoteEl.scrollHeight);
            maxA = Math.max(maxA, opts.attrEl.scrollHeight);
        });
        opts.quoteEl.style.minHeight = maxQ + 'px';
        opts.attrEl.style.minHeight = maxA + 'px';
        // restore whatever testimonial is currently on screen instead of
        // leaving it blank — this runs again later (fonts.ready, window load)
        // after the slider has already shown its first item.
        opts.quoteEl.innerHTML = '"' + items[current].q + '"';
        opts.attrEl.innerHTML =
            '<div class="org">' + items[current].org + '</div>' +
            '<div class="name">' + items[current].name + '</div>';
    }

    measureAndLock();
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measureAndLock);
    }
    window.addEventListener('load', measureAndLock);

    function show(n, fade) {
        current = (n + items.length) % items.length;
        if (fade) {
            opts.quoteEl.style.opacity = 0;
            opts.attrEl.style.opacity = 0;
        }
        setTimeout(function () {
            opts.quoteEl.innerHTML = '“' + items[current].q + '”';
            opts.attrEl.innerHTML =
                '<div class="org">' + items[current].org + '</div>' +
                '<div class="name">' + items[current].name + '</div>';
            opts.quoteEl.style.opacity = 1;
            opts.attrEl.style.opacity = 1;
            if (opts.dotsEl) {
                opts.dotsEl.querySelectorAll('button').forEach(function (b, i) {
                    b.classList.toggle('is-active', i === current);
                });
            }
        }, fade ? 300 : 0);
    }

    function start() {
        clearInterval(timer);
        timer = setInterval(function () { show(current + 1, true); }, opts.interval);
    }

    function stop() { clearInterval(timer); }

    if (opts.dotsEl) {
        items.forEach(function (_, i) {
            var btn = document.createElement('button');
            btn.setAttribute('aria-label', 'Testimonial ' + (i + 1));
            btn.addEventListener('click', function () {
                if (i === current) return;
                show(i, true);
                start();
            });
            opts.dotsEl.appendChild(btn);
        });
    }

    if (opts.pauseEl) {
        opts.pauseEl.addEventListener('mouseenter', stop);
        opts.pauseEl.addEventListener('mouseleave', start);
    }

    show(0, false);
    start();
}
